<script setup lang="ts">
import type { ContainerElement } from '../../types';
import { FormElementsConfigMap } from 'vince-core/pages/form-builder/constants';
import { useFormFillStore } from 'vince-core/pages/form-builder/formFillStore';

const props = defineProps<{
    element: ContainerElement
}>();

const store = useFormFillStore();

const visible = computed((): boolean => {
    return store.isVisible(props.element.visibilityRules);
});

const elementsMap = computed(() => {
    return FormElementsConfigMap;
});

</script>
<template>
    <div
        v-if="visible"
        class="container"
        :class="{'h-container': element.direction === 'horizontal', 'v-container': element.direction === 'vertical'}"
    >
        <component
            :is="elementsMap[el.type]!.formComponent"
            v-for="el in element.children"
            :key="el.id"
            :element="el"
        />
    </div>
</template>

<style scoped>
    .h-container {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        gap: 10px;
    }
</style>
